export interface WorkspaceState {
  active: boolean;
}
